// extracted by mini-css-extract-plugin
module.exports = {"table":"CommercialSizeTable_table__2lDYW"};